import {isEmpty} from 'lodash/lang';
import {ERROR_MESSAGES} from 'configs';

export const getErrorMessage = (code, message) => {
  if (ERROR_MESSAGES.hasOwnProperty(code)) return ERROR_MESSAGES[code];
  if (!isEmpty(message)) return message;

  return ERROR_MESSAGES.not_found;
};
